export const REVALIDATE_AFTER = 5000; // 5 seconds
export const RESET_NAV_CONFIG_CACHE_PARAM = 'resetNavConfig';